import { initializeApp } from "firebase/app";
import { getDownloadURL, getMetadata, getStorage, ref, uploadBytes } from "firebase/storage";

const fireaseConfig = {
	apiKey: "AIzaSyBr8AtlZjTGwMYayPM8BBOCvUzjrrRafow",
	authDomain: "track-your-impact.firebaseapp.com",
	projectId: "track-your-impact",
	storageBucket: "track-your-impact.firebasestorage.app",
	messagingSenderId: "200221127903",
	appId: "1:200221127903:web:d99055e343cee7a477a56a",
	measurementId: "G-6EF97RFEDL",
};

initializeApp(fireaseConfig);
const fbStorage = getStorage();
const kioskApkRef = ref(fbStorage, "kiosk/apk/latest.apk");

export const uploadImage = async (file: { file: Blob; fileName: string }) => {
	const fileRef = ref(fbStorage, `images/${file.fileName}`);
	await uploadBytes(fileRef, file.file);
	let downloadURL = await getDownloadURL(fileRef);
	return downloadURL;
};

export type KioskApkInfo = {
	downloadUrl: string;
	fileName: string;
	version: string;
	uploadedAt: string;
	sizeBytes: number;
};

export const uploadKioskApk = async (file: File, version?: string): Promise<KioskApkInfo> => {
	const normalizedVersion = (version || "").trim();
	const uploadedAt = new Date().toISOString();

	await uploadBytes(kioskApkRef, file, {
		contentType: "application/vnd.android.package-archive",
		cacheControl: "no-store",
		customMetadata: {
			originalFileName: file.name,
			version: normalizedVersion,
			uploadedAt,
		},
	});

	const downloadUrl = await getDownloadURL(kioskApkRef);
	const metadata = await getMetadata(kioskApkRef);

	return {
		downloadUrl,
		fileName:
			metadata.customMetadata?.originalFileName || file.name || "latest.apk",
		version: metadata.customMetadata?.version || normalizedVersion,
		uploadedAt:
			metadata.customMetadata?.uploadedAt || metadata.timeCreated || uploadedAt,
		sizeBytes: Number(metadata.size || 0),
	};
};

export const getKioskApkInfo = async (): Promise<KioskApkInfo> => {
	const [downloadUrl, metadata] = await Promise.all([
		getDownloadURL(kioskApkRef),
		getMetadata(kioskApkRef),
	]);

	const fallbackName = metadata.name?.split("/").pop() || "latest.apk";

	return {
		downloadUrl,
		fileName: metadata.customMetadata?.originalFileName || fallbackName,
		version: metadata.customMetadata?.version || "",
		uploadedAt: metadata.customMetadata?.uploadedAt || metadata.timeCreated || "",
		sizeBytes: Number(metadata.size || 0),
	};
};
